import { ApiMetaDataDTO, PartNumberRuleClassDTO } from 'declarations'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

type ResponseDTO = {
  code: number
  data: PartNumberRuleClassDTO[]
  api_metadata: ApiMetaDataDTO
}

export const useSprPartNumberClassesQuery = (): UseQueryResult<
  PartNumberRuleClassDTO[],
  unknown
> => {
  return useQuery({
    queryKey: ['spr', 'part-number-class-list'],
    queryFn: async () => {
      try {
        const res = await client.get<ResponseDTO>(
          '/supplier_preference_rules/part_number_class/list'
        )
        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
}
